/* This file is autogenerated, see readme.md for instructions */
import TrendSvgIcon from '@bloomreach/banana-theme/icons/trend.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TrendIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TrendSvgIcon />
    </Icon>
  );
});

TrendIcon.displayName = 'TrendIcon';

export default TrendIcon;
